var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        _vm._g(
          _vm._b(
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.dialogVisible,
                width: "680px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                open: _vm.open,
              },
            },
            "el-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "div",
            { staticClass: "login-container-box" },
            [
              _c("img", {
                staticClass: "login-container-left",
                attrs: {
                  src: require("../../../../assets/img/bj_dengruye.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "loginForm",
                  staticClass: "login-form",
                  attrs: {
                    model: _vm.loginForm,
                    rules: _vm.loginRules,
                    autocomplete: "on",
                    "label-position": "top",
                  },
                },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "24px",
                          "font-weight": "500",
                          color: "#272E3B",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("login.signIn")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "username" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "svg-container",
                          style: _vm.language === "en" ? "width: 66px" : "",
                        },
                        [_vm._v(_vm._s(_vm.$t("login.username")))]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                          { name: "trim", rawName: "v-trim" },
                          { name: "fth", rawName: "v-fth" },
                        ],
                        ref: "username",
                        style: "width: 90%",
                        attrs: {
                          autocomplete: "on",
                          name: "username",
                          type: "text",
                          tabindex: "1",
                          maxlength: "30",
                        },
                        model: {
                          value: _vm.loginForm.username,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "username", $$v)
                          },
                          expression: "loginForm.username",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("login.capsLock"),
                        placement: "right",
                        manual: "",
                      },
                      model: {
                        value: _vm.capsTooltip,
                        callback: function ($$v) {
                          _vm.capsTooltip = $$v
                        },
                        expression: "capsTooltip",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "svg-container",
                              style: _vm.language === "en" ? "width: 66px" : "",
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("login.password")))]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            key: _vm.passwordType,
                            ref: "password",
                            style: "width: 90%",
                            attrs: {
                              type: _vm.passwordType,
                              name: "password",
                              tabindex: "2",
                              maxlength: "30",
                              autocomplete: "on",
                              onpaste: "return true",
                              oncopy: "return true",
                              oncut: "return false",
                              oncontextmenu: "return false",
                            },
                            on: {
                              input: _vm.passwordStrength,
                              blur: function ($event) {
                                _vm.capsTooltip = false
                              },
                            },
                            nativeOn: {
                              keyup: [
                                function ($event) {
                                  return _vm.checkCapslock($event)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleLogin($event)
                                },
                              ],
                            },
                            model: {
                              value: _vm.loginForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.loginForm, "password", $$v)
                              },
                              expression: "loginForm.password",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "show-pwd",
                              on: { click: _vm.showPwd },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.passwordType === "password"
                                      ? "eye"
                                      : "eye-open",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.changePassward },
                      model: {
                        value: _vm.remberPassward,
                        callback: function ($$v) {
                          _vm.remberPassward = $$v
                        },
                        expression: "remberPassward",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.rembermer")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "submitBtn",
                          staticStyle: {
                            width: "90%",
                            background: "#0099E5",
                            "margin-top": "20px",
                          },
                          attrs: { type: "primary" },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleLoginCode($event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("login.logIn")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "login-bottom-text",
                      staticStyle: { color: "#0099E5" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleSetRegisterAccount },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.registerAccount")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleForgetPassword },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.forgetPassword")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleForgetAccount },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.forgetAccount")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "login-bottom-text",
                      staticStyle: { color: "#0099E5" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleSendActivationEmail },
                        },
                        [_vm._v(_vm._s(_vm.$t("login.resendActivationEmail")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("slideLogin", {
            ref: "slideLogin",
            attrs: { showData: _vm.showData },
            on: { submit: _vm.submitLoginCode },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("sendActivationEmail", {
        ref: "sendActivationEmail",
        attrs: {
          "destroy-on-close": true,
          width: "30%",
          visible: _vm.sendActivationEmailVisible,
          sendActivationEmailUsername: _vm.sendActivationEmailUsername,
        },
        on: {
          "update:visible": function ($event) {
            _vm.sendActivationEmailVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }